import React from 'react';
import { useNavigate } from 'react-router';
import { SearchSuggestionList } from '@rocco/ui/search/components/SearchSuggestionList';
import type {
    SearchSuggestion,
    SearchSuggestionGroup,
} from '@rocco/ui/search/view-models/search-suggestion';
import { handleSearchSuggestionClick } from '@rocco/ui/search/utils/handle-search-suggestion-click';
import { useRecentlySearched } from '@modules-rocco/search/hook/use-recently-searched';
import { useSearchTracking } from '~/ui-rocco/hooks/use-search-tracking';

interface MobileSearchPageSuggestedGroupsProps {
    query: string;
    group: SearchSuggestionGroup;
}

/**
 * Renders a list of search suggestions grouped by type (e.g., keywords, categories) for mobile view.
 * Handles navigation when a suggestion is clicked using the shared utility function.
 */
export const MobileSearchPageSuggestedGroups: React.FC<
    MobileSearchPageSuggestedGroupsProps
> = ({ query, group }) => {
    const navigate = useNavigate();
    const { addRecentSearch } = useRecentlySearched();
    const trackingConfig = useSearchTracking();

    const onSearchSuggestionClick = (suggestion: SearchSuggestion | string) => {
        handleSearchSuggestionClick(suggestion, {
            onNavigate: navigate,
            addRecentSearch,
            trackingConfig,
        });
    };

    return (
        <div className="px-6 md:px-0">
            <SearchSuggestionList
                group={group}
                query={query}
                onOptionClick={(suggestion) =>
                    onSearchSuggestionClick(suggestion)
                }
            />
        </div>
    );
};
